export const WORK = "working";
export const STUDENT = "studying";
